import { GET_SNOMED_FINDINGS_REQUEST } from "../types";

export const getSnomedFindings = (keywords) => ({
  type: GET_SNOMED_FINDINGS_REQUEST,
  payload: keywords,
});
